import * as yup from "yup";

export const resetPasswordSchema = yup.object().shape({
  newPassword: yup.string().min(8).required(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
});
